import { useState, useEffect, useCallback } from "react"
import { fetchPairSettings, updatePairSettings } from "src/features/qualification/api/qualificationApi"

// Loads + saves the PAIR engine settings for the current org (toggle, limits,
// weights). The Anthropic key is platform-level, not per-org — the config only
// reports its status via `ai_configured`.
export function usePairSettings() {
  const [config, setConfig] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)

  const load = useCallback(async () => {
    setIsLoading(true)
    try {
      setConfig(await fetchPairSettings())
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => { load() }, [load])

  const save = useCallback(async (payload) => {
    setIsSaving(true)
    try {
      const updated = await updatePairSettings(payload)
      setConfig(updated)
      return updated
    } finally {
      setIsSaving(false)
    }
  }, [])

  return { config, isLoading, isSaving, save, reload: load }
}
